import React from 'react';

export const BtnChiTietKhachHang = ({ item, onOpenModalKhachHang }) => {
    return (
        <a href="#!" onClick={() => onOpenModalKhachHang(item)} className="blu btn-link">{item.TenKhachHang}</a>
    );
};